module.exports = __webpack_public_path__ + "img/items.1e4c3e66.svg";